 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","account":"account","admin-panel~tools":"admin-panel~tools","admin-panel":"admin-panel","tools":"tools","all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453":"all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453","all-expenses-list":"all-expenses-list","all-timesheets-list":"all-timesheets-list","contacts":"contacts","estimates":"estimates","features":"features","plans":"plans","project-types":"project-types","projects":"projects","roles":"roles","stages":"stages","users":"users","budget-planner":"budget-planner","dashboard":"dashboard","estimator":"estimator","goals":"goals","issues":"issues","login":"login","logout":"logout","project-accounts":"project-accounts","project-issues":"project-issues","project-issues-home":"project-issues-home","project-parent":"project-parent","project-view":"project-view","register":"register","salary-estimator":"salary-estimator","single-issue":"single-issue","tax-calculator":"tax-calculator"}[chunkId]||chunkId) + "." + {"about":"30a028bc","account":"3be88e8f","admin-panel~tools":"955ebb4d","admin-panel":"49e48dbc","tools":"84cb0150","all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453":"2e35c030","all-expenses-list":"a75ce1fb","all-timesheets-list":"a2cb08d1","contacts":"8eca8a44","estimates":"863f316b","features":"6930a0f9","plans":"b1bd7da9","project-types":"fb3ae7cb","projects":"1b149e53","roles":"dbdb0dc0","stages":"4757126d","users":"20a1f840","budget-planner":"5010cd66","chunk-1b064050":"27babd0c","chunk-2d0aada2":"23567422","chunk-2d0ab2bd":"b3386b77","chunk-2d0bff4b":"98a7cc4b","chunk-2d0ccf1d":"e5e736c7","chunk-2d20f4f6":"3f8b70b0","chunk-2d22c883":"edd02f34","chunk-525a79ec":"57795225","chunk-7c4d096c":"eeaf78a3","chunk-e1bf1014":"e9d88032","dashboard":"0aff48ce","estimator":"81095a48","goals":"91235336","issues":"d62a11f7","login":"d0f77ff7","logout":"c309b23c","project-accounts":"9851dc9f","project-issues":"14300128","project-issues-home":"bbde81ca","project-parent":"4f086575","project-view":"3bdf8b4b","register":"cb46e434","salary-estimator":"cf20c121","single-issue":"70fd93a7","tax-calculator":"271a7fbf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"account":1,"admin-panel~tools":1,"all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453":1,"all-expenses-list":1,"all-timesheets-list":1,"roles":1,"users":1,"budget-planner":1,"chunk-1b064050":1,"chunk-525a79ec":1,"chunk-7c4d096c":1,"chunk-e1bf1014":1,"estimator":1,"issues":1,"login":1,"project-accounts":1,"register":1,"salary-estimator":1,"single-issue":1,"tax-calculator":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","account":"account","admin-panel~tools":"admin-panel~tools","admin-panel":"admin-panel","tools":"tools","all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453":"all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453","all-expenses-list":"all-expenses-list","all-timesheets-list":"all-timesheets-list","contacts":"contacts","estimates":"estimates","features":"features","plans":"plans","project-types":"project-types","projects":"projects","roles":"roles","stages":"stages","users":"users","budget-planner":"budget-planner","dashboard":"dashboard","estimator":"estimator","goals":"goals","issues":"issues","login":"login","logout":"logout","project-accounts":"project-accounts","project-issues":"project-issues","project-issues-home":"project-issues-home","project-parent":"project-parent","project-view":"project-view","register":"register","salary-estimator":"salary-estimator","single-issue":"single-issue","tax-calculator":"tax-calculator"}[chunkId]||chunkId) + "." + {"about":"31d6cfe0","account":"3a5c4d8f","admin-panel~tools":"133d2876","admin-panel":"31d6cfe0","tools":"31d6cfe0","all-expenses-list~all-timesheets-list~contacts~estimates~features~plans~project-types~projects~roles~c7fcd453":"64e9a7eb","all-expenses-list":"d3de4bc2","all-timesheets-list":"d3de4bc2","contacts":"31d6cfe0","estimates":"31d6cfe0","features":"31d6cfe0","plans":"31d6cfe0","project-types":"31d6cfe0","projects":"31d6cfe0","roles":"6bcc295c","stages":"31d6cfe0","users":"6bcc295c","budget-planner":"60f94e1c","chunk-1b064050":"2be99007","chunk-2d0aada2":"31d6cfe0","chunk-2d0ab2bd":"31d6cfe0","chunk-2d0bff4b":"31d6cfe0","chunk-2d0ccf1d":"31d6cfe0","chunk-2d20f4f6":"31d6cfe0","chunk-2d22c883":"31d6cfe0","chunk-525a79ec":"d3de4bc2","chunk-7c4d096c":"dfd166d6","chunk-e1bf1014":"94048bc0","dashboard":"31d6cfe0","estimator":"0576246a","goals":"31d6cfe0","issues":"27e58c15","login":"b5da6e0a","logout":"31d6cfe0","project-accounts":"f136e936","project-issues":"31d6cfe0","project-issues-home":"31d6cfe0","project-parent":"31d6cfe0","project-view":"31d6cfe0","register":"b5da6e0a","salary-estimator":"d59719e8","single-issue":"1f250238","tax-calculator":"30288855"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
